import 'react';
import { css } from 'reakit/styled';
import { palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import _defaultPalette from '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import { isInteractive } from '../Button/styled.js';

var defaultPalette = _defaultPalette({});

var Button = {
  base: css(["border-radius:0px;border:2px solid ", ";color:", ";min-height:44px;padding:0 ", "rem;font-size:15px;text-transform:uppercase;", ";"], function (props) {
    return props.palette === 'default' ? palette('gray700') : 'transparent';
  }, function (props) {
    return props.palette === 'default' ? palette('gray700') : palette(props.palette + "Inverted");
  }, space(4), function (props) {
    return isInteractive(props) && css(["&:focus{outline:2px solid ", ";outline-offset:0;box-shadow:none;background-color:", ";}"], function (props) {
      return props.palette === 'default' ? palette('gray800') : palette();
    }, palette());
  }),
  outlined: css(["background-color:white;border-width:2px;"]),
  ghost: css(["border:2px solid transparent;&:hover{color:", ";fill:", ";background-color:", ";}&:hover:active{color:", ";fill:", ";background-color:", ";}&:focus{border:2px solid white;background-color:unset;color:", ";}"], function (props) {
    return palette(props.palette + "Inverted")(props);
  }, function (props) {
    return palette(props.palette + "Inverted")(props);
  }, palette(), function (props) {
    return palette(props.palette + "Inverted")(props);
  }, function (props) {
    return palette(props.palette + "Inverted")(props);
  }, palette(), function (props) {
    return props.palette === 'default' ? palette('text') : palette(props.palette);
  }),
  interactive: css(["&:focus{border:2px solid white;background-color:", ";color:", ";}", ";"], function (props) {
    return props.palette === 'default' ? palette('gray800') : palette(props.palette + "600");
  }, function (props) {
    return props.palette === 'default' ? 'white' : palette(props.palette + "Inverted");
  }, function (props) {
    return props.palette === 'default' && css(["&:hover{background-color:", ";color:white;}&:hover:active{background-color:", ";}"], palette('gray700'), palette('gray800'));
  }),
  link: css(["border:2px solid transparent;background:unset;"]),
  sizes: {
    small: css(["height:", "rem;font-size:15px;padding:0 ", "rem;"], space(8), space(4)),
    medium: css(["font-size:18px;"])
  }
};
export default Button;